/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { EnergyUsageField } from '../../Enums';
import { Badge } from '@scuf/common';
import React from 'react';
import { formatPriceValue, formatCurrency, formatUnit } from '../Utils';
import descriptors from '../../../../locales/en-US/descriptors';
import { TFunction } from '@scuf/localization/dist/types';

export const getPartialDays = (
  isCompletedData: boolean,
  partialDays: number,
  t: TFunction
) => {
  if (window.location.href.endsWith('portfolio-view')) {
    const d = descriptors.energyManagement;
    if (!isCompletedData) return t(d.PARTIAL_MONTH);
    else return '';
  } else {
    if (!isCompletedData) return `(${partialDays}days)`;
    else return '';
  }
};

export const getTrendChartLabel = (
  category: string | undefined,
  baselineLabel: string,
  previousPeriodLabel: string
) => {
  if (category && category === EnergyUsageField.ENERGY_USAGE)
    return baselineLabel;
  else return previousPeriodLabel;
};

export const getDeviationColor = (deviation: number) => {
  if (deviation >= 0) return 'green';
  else return 'red';
};

export const getBadge = (deviation: number | null) => {
  return (
    deviation !== null &&
    deviation <= 0 && <Badge color={getDeviationColor(deviation)} empty />
  );
};
export const getSummaryBadgeColor = (change: number) => {
  if (change > 0) return 'green';
  else if (change < 0) return 'red';
  else return 'grey';
};

export const getFormattedPriceValue = (
  costSavings: number | null,
  costCurrency: string | undefined
) => {
  return (
    costSavings && formatPriceValue(formatCurrency(costSavings, costCurrency))
  );
};
export const getFormattedUnit = (
  costSavings: number | null,
  costCurrency: string | undefined
) => {
  return costSavings && formatUnit(formatCurrency(costSavings, costCurrency));
};
